import React from 'react';
import { StoreProvider } from './../context/StoreContext';
import { FirebaseProvider } from './../context/FirebaseContext';
import fetch from 'isomorphic-fetch';
import { ParallaxProvider } from 'react-scroll-parallax';

import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';

import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';

const client = new ApolloClient({
    uri: 'https://goodform-dev.myshopify.com/api/2019-07/graphql.json',
    cache: new InMemoryCache(),
    fetch,
    headers: {
        'X-Shopify-Storefront-Access-Token': 'b578a5600cd3bc270f44513eeee3ad7f',
        'Content-Type': 'application/graphql',
        Accept: 'application/json',
    },
});

export const wrapRootElement = ({ element }) => (
    <ApolloProvider client={client}>
        <FirebaseProvider>
            <StoreProvider>
                <ParallaxProvider>{element}</ParallaxProvider>
            </StoreProvider>
        </FirebaseProvider>
    </ApolloProvider>
);
